//% Initialize all the stylized-grid swipers on the current page if it is NOT set to custom
const stylized_grid_swipers = document.querySelectorAll(".stylized-grid:not(.custom)");

//$ Loop through all the valid (none-custom) stylized-grid swipers and initialize them
stylized_grid_swipers.forEach((stylized_grid) => {
  init_stylized_grid_swiper(stylized_grid);
});



//# Fn initializes a swiper instance for 'stylized-grid' snippet
/**
 * Initializes a swiper instance for the specified 'stylized-grid' section
 * @param {string} parent_element - The parent node or parent selector of the swiper container
 * @param {object} custom_params - [optional] Custom parameters to be added to the default swiper params specified in app.js
 * @example
 * init_stylized_grid_swiper(".stylized-grid", {
 *   speed: 2000,
 * });
 */
function init_stylized_grid_swiper(parent_element, custom_params = {}) {
  let stylized_grid_parent;

  //% Check if parent_element is an HTML element
  if (parent_element instanceof HTMLElement) {
    //$ If it is then use that as the parent element
    stylized_grid_parent = parent_element;
  } else {
    //$ If it is not then use the argument string as the parent selector
    stylized_grid_parent = document.querySelector(parent_element);
  }

  //% Get the stylized grid container element
  // const stylized_grid_parent = document.querySelector(parent_element);

  //% If it can't find the element then exit function
  if (!stylized_grid_parent) {
    console.log('no container matching "' + parent_element + '" could be found');
    return;
  }

  //% If the parent container exist then store the swiper elements
  const swiperEl = stylized_grid_parent.querySelector("swiper-container");
  const nav_prev = stylized_grid_parent.querySelector(".btn.prev");
  const nav_next = stylized_grid_parent.querySelector(".btn.next");

  //% Define the default swiper parameters
  const default_params = {
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    effect: "fade",
    speed: 500,
    grabCursor: true,
    navigation: {
      prevEl: nav_prev,
      nextEl: nav_next,
    },
  };

  //% Merge the default and custom parameters
  const params = {
    ...default_params,
    ...custom_params,
  };

  //$ Initialize the swiper (helpers.js)
  swiper_init(swiperEl, params);
}
